import React from 'react'
import {Colors} from '../../../styledComponents/Constants'

interface Props {
    size?: number;
    color?: string;
    className?: string;
}

export const ImgAddIcon: React.FC<Props> = props => {
    return (
        <svg
            width={props.size ?? 19}
            height={props.size ?? 19}
            viewBox={'0 0 19 19'}
            fill={props.color ?? Colors.AccentDark}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M16 5V7.99C16 7.99 14.01 8 14 7.99V5H11C11 5 11.01 3.01 11 3H14V0H16V3H19V5H16ZM13 9V6H10V3H2C0.9 3 0 3.9 0 5V17C0 18.1 0.9 19 2 19H14C15.1 19 16 18.1 16 17V9H13ZM2 17L5 13L7 16L10 12L14 17H2Z'}
                fill={props.color ?? Colors.AccentDark}
            />
        </svg>
    )
}

export const SearchIcon: React.FC<Props> = props => {
    return (
        <svg
            width={props.size ?? 18}
            height={props.size ?? 18}
            viewBox={'0 0 18 18'}
            fill={props.color ?? Colors.AccentDark}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M16.2614 17.7183L10.5341 11.9829C10.0227 12.3926 9.43466 12.7169 8.76989 12.9559C8.10511 13.1949 7.39773 13.3144 6.64773 13.3144C4.78977 13.3144 3.2175 12.6702 1.93091 11.3817C0.643636 10.0926 0 8.51778 0 6.65718C0 4.79659 0.643636 3.22174 1.93091 1.93263C3.2175 0.644211 4.78977 0 6.64773 0C8.50568 0 10.0783 0.644211 11.3656 1.93263C12.6522 3.22174 13.2955 4.79659 13.2955 6.65718C13.2955 7.40825 13.1761 8.11664 12.9375 8.78236C12.6989 9.44808 12.375 10.037 11.9659 10.5491L17.7188 16.3101C17.9063 16.4979 18 16.7283 18 17.0014C18 17.2745 17.8977 17.5135 17.6932 17.7183C17.5057 17.9061 17.267 18 16.9773 18C16.6875 18 16.4489 17.9061 16.2614 17.7183ZM6.64773 11.266C7.92614 11.266 9.01295 10.8181 9.90818 9.92228C10.8027 9.02578 11.25 7.93741 11.25 6.65718C11.25 5.37696 10.8027 4.28859 9.90818 3.39209C9.01295 2.49627 7.92614 2.04836 6.64773 2.04836C5.36932 2.04836 4.2825 2.49627 3.38727 3.39209C2.49273 4.28859 2.04545 5.37696 2.04545 6.65718C2.04545 7.93741 2.49273 9.02578 3.38727 9.92228C4.2825 10.8181 5.36932 11.266 6.64773 11.266Z'}
                fill={props.color ?? Colors.AccentDark}
            />
        </svg>
    )
}

export const ArrowIcon: React.FC<Props> = props => {
    return (
        <svg
            width={props.size ?? 30}
            height={props.size ?? 60}
            viewBox={'0 0 30 60'}
            fill={props.color ?? 'white'}
            xmlns={'http://www.w3.org/2000/svg'}
            className={props.className}
        >
            <path
                d={'M1.33257 50.8054L19.0091 29.9732L1.33257 9.14094C-0.444191 7.04698 -0.444191 3.66443 1.33257 1.57047C3.10934 -0.52349 5.9795 -0.52349 7.75626 1.57047L28.6674 26.2148C30.4442 28.3087 30.4442 31.6913 28.6674 33.7852L7.75626 58.4295C5.9795 60.5235 3.10934 60.5235 1.33257 58.4295C-0.398633 56.3356 -0.444191 52.8993 1.33257 50.8054Z'}
                fill={props.color ?? 'white'}
            />
        </svg>
    )
}

export const ImgCompleteIcon: React.FC<Props> = props => {
    return (
        <svg
            width={props.size ?? 120}
            height={props.size ?? 120}
            viewBox={'0 0 120 120'}
            fill={props.color ?? '#00838A'}
            xmlns={'http://www.w3.org/2000/svg'}
        >
            <path
                d={'M114.25,60 C114.25,30.0384504 89.958632,5.75 60,5.75 C30.0317671,5.75 5.75,30.0332257 5.75,60 C5.75,89.9667741 30.0317671,114.25 60,114.25 C89.958632,114.25 114.25,89.9615496 114.25,60 Z M119.416667,60 C119.416667,92.8151595 92.811964,119.416667 60,119.416667 C27.1782264,119.416667 0.583333333,92.8201759 0.583333333,60 C0.583333333,27.179824 27.1782264,0.583333333 60,0.583333333 C92.811964,0.583333333 119.416667,27.1848402 119.416667,60 Z M55.0169252,73.9106724 L86.0706978,42.8568994 C87.0795525,41.8480449 88.7152287,41.8480449 89.7240829,42.8568994 C90.7329376,43.8657537 90.7329376,45.5014299 89.7240829,46.5102844 L56.8436177,79.3907496 C55.8347635,80.3996043 54.1990873,80.3996043 53.1902326,79.3907496 L34.9233075,61.1238244 C33.914453,60.1149702 33.914453,58.479294 34.9233075,57.4704393 C35.9321619,56.4615851 37.5678381,56.4615851 38.5766925,57.4704393 L55.0169252,73.9106724 Z'}
                fill={props.color ?? '#00838A'}
            />
        </svg>
    )
}